/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why show several formulas?`)
};

const es_iw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué mostrar varias fórmulas?`)
};

const de_iw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum werden mehrere Formeln angezeigt?`)
};

const nl_iw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom worden meerdere formules getoond?`)
};

const fr_iw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi afficher plusieurs formules ?`)
};

const it_iw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché mostrare più formule?`)
};

const pt_br2_iw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que mostrar várias fórmulas?`)
};

const pt_iw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque mostrar várias fórmulas?`)
};

const ja_iw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜ複数の計算式が表示されるのですか?`)
};

const zh_iw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么要显示多个公式？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iw_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iw_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iw_faq_q2", locale)
	if (locale === "en") return en_iw_faq_q2(inputs)
	if (locale === "es") return es_iw_faq_q2(inputs)
	if (locale === "de") return de_iw_faq_q2(inputs)
	if (locale === "nl") return nl_iw_faq_q2(inputs)
	if (locale === "fr") return fr_iw_faq_q2(inputs)
	if (locale === "it") return it_iw_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_iw_faq_q2(inputs)
	if (locale === "pt") return pt_iw_faq_q2(inputs)
	if (locale === "ja") return ja_iw_faq_q2(inputs)
	return zh_iw_faq_q2(inputs)
};